<div [ngClass]="{
       'border-t-[3px] border-primary shadow-bento relative z-10': theme === 'primary'
     }">
  <div class="w-full" [ngClass]="{
           'bg-surface-container-lowest': theme === 'primary' || theme === 'light',
           'bg-success': theme === 'success',
           'bg-error': theme === 'error',
           'bg-premium-dark': theme === 'premium'
        }">
    <div class="grid px-4 pt-5 pb-2 font-bold cursor-pointer grid-cols-10 sm:pt-5 place-items-center" [ngClass]="{
             'text-on-background': theme === 'primary',
             'text-white': (theme === 'success' || theme === 'error'),
             'text-premium': theme === 'premium',
             'text-primary': titleColor === 'primary'
         }">
      <div class="text-left col-span-1">
        <ng-content select="[leftLinks]"></ng-content>
      </div>
      <div class="flex flex-col items-center text-center col-span-8" [ngClass]="{
               'uppercase': theme !== 'primary',
               'text-xl md:text-2xl leading-tight': theme === 'primary'
           }">
        <ion-icon *ngIf="icon !== undefined" [name]="icon" class="py-2 text-5xl"></ion-icon>
        <ion-icon *ngIf="iconSrc !== undefined" [src]="iconSrc" class="py-2 text-5xl"></ion-icon>
        <span *ngIf="title !== undefined">{{title}}</span>
      </div>
      <div class="text-right cursor-pointer col-span-1">
        <ng-content select="[rightLinks]"></ng-content>
      </div>
    </div>
  </div>
  <div class="px-6 py-2 text-center mobile:py-5 empty:hidden" [ngClass]="{
           'bg-surface-container-lowest text-on-surface-variant': theme === 'primary',
           'text-white': (theme === 'success' || theme === 'error'),
           'bg-success': theme === 'success',
           'bg-error': theme === 'error',
           'bg-surface-container-lowest': theme === 'light'
       }">
    <ng-content select="[description]"></ng-content>
  </div>
</div>
